/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=5a99c210&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5a99c210&lang=stylus"
import "./index.vue?vue&type=style&index=1&id=5a99c210&lang=stylus&scoped=true"
import "./index.vue?vue&type=style&index=2&id=5a99c210&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a99c210"]])

export default __exports__